import AOS from 'aos';
import counterUp from 'counterup2'

// Initialize AOS
if (AOS && typeof AOS.init === 'function') {
	AOS.init({
		once: true,
		duration: 800,
		easing: 'ease-in-out-sine',
	});
} else {
	console.error('AOS is not loaded or initialized properly.');
}

const callback = entries => {
	entries.forEach( entry => {
		const el = entry.target
		if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
			counterUp( el, {
				duration: 2000,
				delay: 16,
			} )
			el.classList.add( 'is-visible' )
		}
	} )
}

const IO = new IntersectionObserver( callback, { threshold: 1 } )

const counters = Array.from(document.querySelectorAll('.counter'))
    .filter((el) => !el.closest('.content-image-animated-block'));

counters.forEach(function (userItem) {
    IO.observe(userItem);
})


const easeOutCubic = function (t, b, c, d) {
	var ts = (t /= d) * t;
	var tc = ts * t;
	return b + c * (tc + -3 * ts + 3 * t);
}


document.addEventListener('aos:in:savings-box', ({ detail }) => {
		
	let playCount = 0;

	const savingsBox = document.getElementById('pdpm-savings-amount');
	const observer = new IntersectionObserver(() => {
		

		if (playCount === 0) {
			setTimeout(function() {
				const countUp = new CountUp('pdpm-savings-amount', 397896, {
					prefix: '$',
					useEasing: true,
					easingFn: easeOutCubic,
					duration: 2.2
				});
				
				if (!countUp.error) {
					countUp.start();
				} else {
					console.error(countUp.error);
				}
		
			}, 2000);
		}
		playCount++;
	});

	observer.observe(savingsBox);


});


document.addEventListener('aos:in:piggy-coin', ({ detail }) => {
	let playCount = 0;
	const roi = document.getElementById('roi-percent');

	const observer = new IntersectionObserver(() => {
		

		if (playCount === 0) {
			setTimeout(function() {
				const countUp = new CountUp('roi-percent', 418, {
					useEasing: true,
					easingFn: easeOutCubic,
					duration: 3
				});
				
				if (!countUp.error) {
					countUp.start();
				} else {
					console.error(countUp.error);
				}
		
			}, 700);
		}
		playCount++;
	});

	observer.observe(roi);
});

document.addEventListener('aos:in:gear-box', ({ detail }) => {

	let playCount = 0;
	const roi = document.getElementById('turnover-savings');

	const observer = new IntersectionObserver(() => {
		

		if (playCount === 0) {
			setTimeout(function() {
				const countUp = new CountUp('turnover-savings', 126054, {
					useEasing: true,
					easingFn: easeOutCubic,
					duration: 3
				});
				
				if (!countUp.error) {
					countUp.start();
				} else {
					console.error(countUp.error);
				}
		
			}, 700);
		}
		playCount++;
	});

	observer.observe(roi);

});
